import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../../../../utils/Translations';
import {
	formatEffectAsPlainText, needVipYesterdayOffer,
}                   from '../../../../Dailybonus/dailyBonusHelpers';

const DailybonusTopUpDescr = props => {
	const {effect, conditions} = props;
	const needVip              = needVipYesterdayOffer(conditions);

	return (
		<div className='dailybonus__mobile--item__description'>
			<div className="dailybonus__mobile--item__description--bonus-effect">{formatEffectAsPlainText(effect)}</div>
			<div className="dailybonus__mobile--item__description--bonus-title">{needVip ? 'VIP BONUS' : 'BONUS'}</div>
			<div className="dailybonus__mobile--item__description--bonus-info h-text-light">{Translations.get('TopUpPercent365Charge')}</div>
		</div>
	);
};

DailybonusTopUpDescr.propTypes = {
	effect:     PropTypes.object,
	conditions: PropTypes.array,
};

DailybonusTopUpDescr.defaultProps = {
	purchased:  false,
	conditions: [],
};

export default DailybonusTopUpDescr;